var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { UserSsoStateKeyFactory } from '../query-key-factories/UserSsoStateKeyFactory';
export const useGetUserSsoState = ({ accessToken, email, }) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const query = useQuery({
        queryKey: UserSsoStateKeyFactory.byEmail(email),
        queryFn: async () => lucidSdk.authenticationClient().getUserSsoState(email, accessToken),
        networkMode: 'always',
        retry: false,
    });
    return query;
};
_react_refresh_temp_1(useGetUserSsoState, "H/nX1eMsJ0bsH20/D0j9QAs2SDk=", false, () => [useLucidSdk, useQuery]);
